import { Fade } from 'react-reveal';
import AppleWatchPlus from "../../assets/images/webp/appleWatch.webp";
import AndroidWatch from "../../assets/images/webp/androidWatches.webp";
import IPhone from "../../assets/images/webp/iPhone.webp";
import Apple from "../../assets/images/webp/apple.webp";
import Android from "../../assets/images/webp/android.webp";

import VerticalGap from "../../components/VerticalGap";
import CustomButton from "../../components/CustomButton";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const AppleAndroidProducts = () => {
  const onSignUp = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
  };
  return (
    <div className="apple-android-section">
      <div className="apple-android-products">
        <Fade left >
          <div className="apple-left">
            <div className="sub-title">Developed for</div>
            <div className="title">
              Apple & Android <br />
              products alike
          </div>
            <div className="para">
              Making fitness a priority shouldn't hinge on whether you're Team Apple or Team Android. Join Team Omni-Active®...
              and bring your favorite device with you.
          </div>
          </div>
        </Fade>
        <Fade right >
          <div className="apple-right">
            <div className="image-text">
              <div className="image">
                <img src={AppleWatchPlus} alt="" />
              </div>
              <div className="text">Apple Watch+</div>
            </div>
            <div className="image-text">
              <div className="image">
                <img src={AndroidWatch} alt="" />
              </div>
              <div className="text">Android Watches</div>
            </div>
            <div className="image-text">
              <div className="image">
                <img src={IPhone} alt="" />
              </div>
              <div className="text">Both Iphone & Androids</div>
            </div>
          </div>
        </Fade>
      </div>
      <VerticalGap />
      <div className="available">
        <div className="heading">Available on</div>
        <div className="image-groups">
          <div className="image-text">
            <div className="image">
              <img src={Android} alt="" />
            </div>
            <div className="text">Android</div>
          </div>
          <div className="image-text">
            <div className="image">
              <img src={Apple} alt="" />
            </div>
            <div className="text">Apple</div>
          </div>
        </div>
        <div className="custom-btn">
          <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={onSignUp}>
            Sign Up
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
export default AppleAndroidProducts;
